import { createSlice } from "@reduxjs/toolkit";

const questionnairesSlice = createSlice({
  name: "questionnaires",
  initialState: {
    questionnairesById: [],
    completedQuestionnaires: [],
    pendingTopicsQuestionnaires: [],
  },
  reducers: {
    setPendingTopicsQuestionnaires(state, { payload }) {
      state.pendingTopicsQuestionnaires = payload;
    },
    setQuestionnairesById(state, { payload }) {
      state.questionnairesById = payload;
    },
    setCompletedQuestionnaires(state, { payload }) {
      state.completedQuestionnaires = payload;
    },
    clearQuestionnaires(state) {
      state.questionnairesById = [];
      state.completedQuestionnaires = [];
      state.pendingTopicsQuestionnaires = [];
    },
  },
});

export const {
  clearQuestionnaires,
  setQuestionnairesById,
  setCompletedQuestionnaires,
  setPendingTopicsQuestionnaires,
} = questionnairesSlice.actions;

export default questionnairesSlice.reducer;
